import { InfoCircleFilled } from '@ant-design/icons';
import { throwAxiosError } from '@mst-fe/shared';
import { Button, Space } from 'antd';
import axios from 'axios';
import { useEffect, useLayoutEffect, useState } from 'react';
import { useLocation } from 'react-router';

import styles from './OutOfDateBanner.module.css';

import { LONG_REQUEST_TIMEOUT } from '../constants';
import { PeriodicRequest } from '../services/periodic-request';
import { axiosOptions } from '../services/requests';
import ZoeRoute from '../utils/routes';
import pageVersionInfo from '../version-info';

const AUTO_VERSIONING_INTERVAL_MS = 60 * 1000;

export async function getVersion() {
  const versionInfo = await throwAxiosError(axios.get<{ version: string }>('/version-info.json', axiosOptions(LONG_REQUEST_TIMEOUT)));
  return versionInfo.version;
}

export default function OutOfDateBanner() {
  const [isUpToDate, setIsUpToDate] = useState(true);

  const location = useLocation();
  const routesList = Object.values(ZoeRoute);
  useLayoutEffect(() => {
    if (routesList.includes(location.pathname as ZoeRoute) && !location.state && !isUpToDate) {
      window.location.reload();
    }
  }, [location]);

  useEffect(() => {
    let stop: (() => void) | undefined = undefined;

    const checkVersion = new PeriodicRequest({
      interval: AUTO_VERSIONING_INTERVAL_MS,

      onPeriodicRequest: async () => await getVersion(),
      onPeriodicRequestResult: (newVersion) => {
        // Compare the release captured in this page's HTML with the current server release.
        const upToDate = newVersion === pageVersionInfo.version;
        setIsUpToDate(upToDate);
        if (!upToDate) {
          // we can stop checking until the next reload
          stop?.();
        }
      },
    });
    stop = checkVersion.start();

    return stop;
  }, []);

  return isUpToDate ? null : (
    <Space className={styles.outOfDateAlert}>
      <InfoCircleFilled className={styles.outOfDateInfoIcon} />
      <span>A new version of this web application is available.</span>
      <Button type="link" className={styles.outOfDateAlertRefresh} onClick={() => window.location.reload()}>
        Please refresh the page.
      </Button>
    </Space>
  );
}
